import { CALENDLY_URL } from '@/lib/brand';

/** Open Calendly in a new browser tab. */
export function openCalendly() {
  if (typeof window === 'undefined') return;
  window.open(CALENDLY_URL, '_blank', 'noopener,noreferrer');
}

/** No-op kept for backward compatibility with previous popup-preload approach. */
export function preloadCalendly() {}
